import { useDispatch, useSelector } from "react-redux";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { SavedTab } from "../../components/account/tabs/SavedTab";
import AccountTab from "../../components/account/AccountTab";
import AccountSidebar from "../../components/account/AccountSidebar";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import AccountTabModal from "../../components/account/AccountTabModal";
import AccountProfileSection from "../../components/account/AccountProfileSection";
import { useLocation } from "react-router-dom";
import { EditSavedFolderModal } from "../../components/Modals/account/EditSavedFolderModal";
import { DeleteSavedFolderModal } from "../../components/Modals/account/DeleteSavedFolderModal";
import { createFolder, deleteSavedFolders, getSavedFolders, renameSavedFolders, resetLoadingMore, savedVideoList } from "../../redux/ApiSlice/SavedVideosSlice";

export default function Saved() {
    const dispatch = useDispatch();
    const location = useLocation();
    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const savedVideo = useSelector((state) => state.savedVideos);
    const { loading, SavedFolderList, loadingMore, nextPage } = savedVideo;
    const { User_profile } = ProfileDetails;
    const [show, setShow] = useState(false);
    const [activeTab, setActiveTab] = useState("");
    const ref = useRef(null);
    const savedScrollRef = useRef(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false); // for sidebar
    const [lockScroll, setLockScroll] = useState(false); // lock background when move drawer is open
    const [showFolders, setShowFolders] = useState(false);

    const [EditModal, setEditModal] = useState(false); //rename saved folder modal
    const [selectFolderId, setSelectFolderId] = useState("");
    const [selectFolder, setSelectFolder] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false); //delete saved folder modal

    const handleOpenEditModal = (id) => {
        setEditModal(!EditModal);
        setSelectFolderId(id);
        const data = SavedFolderList?.data?.filter((item) => item.id === id)
        setSelectFolder(data[0]);
    };

    const renameFolderName = async (folderName, folderId) => {
        await dispatch(
            renameSavedFolders({ name: folderName, folderId: folderId || selectFolderId })
        );
        dispatch(getSavedFolders(User_profile?.id));
        setEditModal(false);
    };

    const handleOpenDeleteModal = (id) => {
        setDeleteModal(!deleteModal);
        setSelectFolderId(id);
        const data = SavedFolderList?.data?.filter((item) => item.id === id)
        setSelectFolder(data[0]);
    };

    const deleteCreatedFolder = async (id) => {
        await dispatch(deleteSavedFolders(id));
        setDeleteModal(false);
        dispatch(getSavedFolders(User_profile?.id));
    };
    const fetchData = useCallback(() => {
        if (User_profile?.id) {
            dispatch(getSavedFolders(User_profile.id));
        }
    }, [dispatch, User_profile?.id]);

    const handleSavedScroll = useCallback(() => {
        const container = savedScrollRef.current;
        if (!container || loadingMore || !nextPage) return;

        const { scrollTop, scrollHeight, clientHeight } = container;
        const threshold = 50;

        if (scrollHeight - scrollTop - clientHeight <= threshold) {
            dispatch(savedVideoList({ nextUrl: nextPage, isLoadMore: true }));
        }
    }, [dispatch, loadingMore, nextPage]);


    const handleCreateFolder = async (value) => {
        if (value !== "") {
            await dispatch(createFolder({ name: value, userId: User_profile?.id })).unwrap();
            fetchData();
        } else {
            alert("Please enter folder name");
        }
    };

    const handleClickOutside = () => {
        setShow(false);
        setActiveTab("");
    };
    useOutsideClick(ref, handleClickOutside);

    const openDrawer = () => setIsDrawerOpen(true);
    const closeDrawer = () => setIsDrawerOpen(false);

    const handleMoveDrawerToggle = useCallback((isOpen) => {
        setLockScroll(isOpen);
    }, []);

    useEffect(() => {
        document.body.style.overflow = (isDrawerOpen || lockScroll) ? "hidden" : "";
        const container = savedScrollRef.current;
        if (container) {
            container.style.overflowY = (isDrawerOpen || lockScroll) ? "hidden" : "scroll";
        }
        return () => {
            document.body.style.overflow = "";
            if (container) {
                container.style.overflowY = "scroll";
            }
        };
    }, [isDrawerOpen, lockScroll]);

    //initial fetch
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        dispatch(resetLoadingMore());
        fetchData();

        // Check if we should show folders view (coming back from folder detail)
        if (location.state?.showFolders) {
            setShowFolders(true);
        }
    }, [fetchData, dispatch, location.state]);

    useEffect(() => {
        const container = savedScrollRef.current;
        if (container) {
            container.addEventListener('scroll', handleSavedScroll);
            return () => container.removeEventListener('scroll', handleSavedScroll);
        }
    }, [handleSavedScroll]);

    return (
        <Fragment>
            <div
                ref={savedScrollRef}
                className={`bg-[#fff] dark:bg-[#1E1D21] overflow-hidden h-full relative ${(!isDrawerOpen && !lockScroll) ? "overflow-y-scroll" : ""}`}
            >
                <AccountProfileSection
                    show={show}
                    setShow={setShow}
                    isDrawerOpen={isDrawerOpen}
                    setActiveTab={setActiveTab}
                    handleOpenSideBar={openDrawer}
                    handleCloseSideBar={closeDrawer}
                />

                <div className="sticky top-0 z-50 ">
                    <AccountTab activeTab={"Saved"} />
                </div>

                <SavedTab
                    loading={loading}
                    nextPage={nextPage}
                    loadingMore={loadingMore}
                    onMoveDrawerToggle={handleMoveDrawerToggle}
                    handleCreateFolder={handleCreateFolder}
                    handleRenameFolder={renameFolderName}
                    showFolders={showFolders}
                    setShowFolders={setShowFolders}
                    SavedFolderList={SavedFolderList}
                    handleOpenEditModal={handleOpenEditModal}
                    handleOpenDeleteModal={handleOpenDeleteModal}
                />

                <div className="grid grid-cols-12 overflow-hidden">
                    <div className="col-span-12">
                        <AccountSidebar
                            openDrawer={openDrawer}
                            closeDrawer={closeDrawer}
                            isDrawerOpen={isDrawerOpen}
                            setIsDrawerOpen={setIsDrawerOpen}
                        />
                    </div>
                </div>
            </div>

            {show && (
                <div className={"absolute h-full w-full top-0 overflow-hidden"}>
                    <div
                        className="absolute h-screen w-full top-0 opacity-100 bg-opacity-70 bg-black z-50"
                        onClick={handleClickOutside}
                    />
                    <div
                        ref={ref}
                        className="absolute top-0 left-4 z-50 w-[90%] h-[-webkit-fill-available] mt-4 mb-3 flex justify-center rounded-lg  bg-black duration-1000 transform opacity-100"
                    >
                        <AccountTabModal
                            ref={ref}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </div>
                </div>
            )}

            <EditSavedFolderModal
                selectFolderId={selectFolderId}
                EditModal={EditModal}
                selectFolder={selectFolder}
                handleOpenEditModal={handleOpenEditModal}
                renameFolderName={renameFolderName}
            />

            <DeleteSavedFolderModal
                open={deleteModal}
                handleOpen={handleOpenDeleteModal}
                selectFolder={selectFolder}
                deleteCreatedFolder={deleteCreatedFolder}
            />
        </Fragment>
    )
}
